const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'https://peekr-production.up.railway.app';
const tokens = new Map();
const pending = new Map();

export function saveViewerToken(code, token) {
  if (typeof token !== 'string' || !/^[a-f0-9]{64}$/.test(token)) throw new Error('Invalid showing authorization.');
  const value = { token, expiresAt: Date.now() + 47 * 60 * 60 * 1000 };
  tokens.set(code, value);
  try { sessionStorage.setItem(`peekr:viewer:${code}`, JSON.stringify(value)); } catch { /* memory works when storage is unavailable */ }
}
export function getViewerToken(code) {
  let value = tokens.get(code);
  try { if (!value) value = JSON.parse(sessionStorage.getItem(`peekr:viewer:${code}`)); } catch { return null; }
  return value?.expiresAt > Date.now() ? value.token : null;
}
export async function viewerHeaders(code) {
  let token = getViewerToken(code);
  if (!token) {
    if (!pending.has(code)) pending.set(code, (async () => {
      const response = await fetch(`${SERVER_URL}/viewer-session/${encodeURIComponent(code)}`, { method: 'POST' });
      const result = await response.json();
      if (!response.ok) throw new Error(result.error || 'Could not authorize gallery access.');
      saveViewerToken(code, result.token);
      return result.token;
    })().finally(() => pending.delete(code)));
    token = await pending.get(code);
  }
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
}
